import script from "./Reciepts.vue?vue&type=script&setup=true&lang=js"
export * from "./Reciepts.vue?vue&type=script&setup=true&lang=js"

import "./Reciepts.vue?vue&type=style&index=0&id=db66b0ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db66b0ea"]])

export default __exports__